export default "__VITE_ASSET__DpN4knB2__"